<div class="top-bar-main c-main-bgcolor c-main-color">
    <div c-loader></div>
    <section class="left-aligned">
        <div c-service-menu></div>
        <c-top-menu show="{ fixed: true }" class="new-menu"></c-top-menu>
    </section>
    <section class="right-aligned">
        <c-top-menu show="{ extras: true, menus: true }" class="main-menu"></c-top-menu>
        <div class="c-header-logo right-aligned-logo"></div>
        <div c-global-search class="item"></div>
        <div c-document-assistant class="item"></div>
    </section>
</div>